import styled from 'styled-components';

export const LayoutWrapper = styled.div`
  .ant-layout-content {
    min-height: calc(100vh - 135px);
    background-color: #eff2f5;
  }
`;
